export const subagentJson = {
  SubAgent_Id: "",
  SubAgent_Name: "",
  Created_By: "",
  Created_On: "",
  Modified_By: "",
  Modified_On: "",
  Active: "",
  Country_Id: "0",
  SubAgent_Address: "",
  Contact_Person: "",
  Contact_Number: "0",
  Contact_Email: "",
  Commision_Percentage_PG: "0",
  Commision_Percentage_UG: "0",
  Commision_Percentage_Other: "0",
  Commision_Including_GST: "0",
  Split_Percentage: "0",
  Commission_Duration: "0",
  Lumpsum_Commision: "0",
  Attachment_Name: "",
};

export const subagentInvoiceFilter = {
  month: "",
  year: "",
  subagentid: "",
  invoicedRaisedFrom: "",
  invoicedRaisedTo: "",
  searchtxt: "",
  PageSize: 25,
  PageNo: 1,
};

